import EverTrue from 'app';
import BaseRouter from 'base/base-router';
import EventPageController from 'apps/events/controllers/events-page-controller';
import EventbriteSettingsController from 'apps/events/controllers/eventbrite-settings-controller';
import EventsController from 'apps/events/controllers/events-controller';
import IsGated from 'components/is-gated';

class EventsRouter extends BaseRouter {
  static initClass() {
    this.prototype.routes = {
      'events(/)': 'index',
      'events/eventbrite': 'eventbrite',
      'events/:event_id(/)': 'eventPage',
    };
  }

  index() {
    this.currentView = (
      <IsGated feature="events_facebook">
        {({ show: has_fb }) => (
          <IsGated feature="events_eventbrite">
            {({ show: has_eb }) => (has_fb || has_eb ? <EventsController /> : null)}
          </IsGated>
        )}
      </IsGated>
    );
    EverTrue.execute('setBrowserTitle', 'Events');
    EverTrue.page.mount(this.currentView);
  }

  eventPage(event_id) {
    EverTrue.track.setReferrer('event detail');
    this.currentView = <EventPageController event_id={Number(event_id)} filters={['all']} />;
    EverTrue.execute('setBrowserTitle', 'Events');
    EverTrue.page.mount(this.currentView);
  }

  eventbrite() {
    this.currentView = <EventbriteSettingsController />;
    EverTrue.execute('setBrowserTitle', 'Events');
    EverTrue.page.mount(this.currentView);
  }
}

EventsRouter.initClass();
export default EventsRouter;
